import { render, staticRenderFns } from "./WithdrawFunds.vue?vue&type=template&id=485c6248"
import script from "./WithdrawFunds.vue?vue&type=script&lang=js"
export * from "./WithdrawFunds.vue?vue&type=script&lang=js"
import style0 from "./WithdrawFunds.vue?vue&type=style&index=0&id=485c6248&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports